import React from 'react';
import { Button } from './Button';
import { cn } from '../lib/utils';
import ProductTag from './ProductTag';
const ProductCard = React.forwardRef(({ title, image, tag, price, retailPrice, onAddToCart, attributes, className, hasPriceRange, showPrice = true, }, ref) => {
    const handleAddToCart = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onAddToCart?.();
    };
    return (React.createElement("article", { ref: ref, className: cn('bg-brand-grey py-2.5 relative min-w-[173px] md:min-w-60 md:max-w-[325px] w-full h-full', className) },
        React.createElement("h1", { className: "absolute w-px h-px p-0 overflow-hidden clip-rect(0,0,0,0) whitespace-nowrap border-0" }, title || 'Product Name'),
        tag && React.createElement(ProductTag, { tag: tag }, tag),
        React.createElement("img", { className: "mb-3.5 md:mt-2.5 w-full h-[144px] md:h-[169px] object-contain", ...image }),
        React.createElement("section", { className: cn([
                'flex flex-col py-2.5 xl:py-3 divide-y divide-brand-rule-grey border-t border-brand-rule-grey text-black',
                showPrice ? 'xl:py-3' : 'xl:pt-0',
            ]) },
            showPrice && (React.createElement("div", { className: "pb-2.5 xl:pb-3 px-2.5 md:px-3.5 xl:px-5 text-sm xl:text-base " },
                React.createElement("span", { className: cn('font-medium', !retailPrice && 'md:font-normal') },
                    hasPriceRange ? 'From' : '',
                    " ",
                    price),
                retailPrice && showPrice && (React.createElement("span", { className: "font-normal" },
                    " | ",
                    retailPrice,
                    " retail")))),
            attributes && (React.createElement("div", { className: "hidden md:block" },
                React.createElement(AttributesList, { attributes: attributes }))),
            React.createElement("div", { className: "pt-2.5 md:pt-3 xl:pt-5 px-2.5 md:px-3.5 xl:px-5 flex flex-wrap md:flex-nowrap justify-between items-center gap-2.5" },
                React.createElement("p", { className: cn('flex-1 truncate break-words text-balance font-medium md:text-lg xl:text-2xl [&>a]:after:absolute [&>a]:after:inset-0 [&>a]:after:content-[""] [&>a]:after:hover:cursor-pointer [&>a]:after:hover:border-brand-rule-grey [&>a]:after:focus:border-brand-rule-grey [&>a]:after:hover:border [&>a]:after:focus:border [&>a]:after:hover:shadow-product-card [&>a]:after:focus:shadow-product-card') }, title),
                onAddToCart && (React.createElement(Button, { className: "text-xl font-bold py-1.5 px-4 relative z-20 ", onClick: handleAddToCart, size: "sm" }, "Add"))))));
});
const MultipleAttributeDictionary = {
    SIZE: 'Multiple sizes',
    FLAVOR: 'Multiple flavors',
    FLAVOR_SIZE: 'Multiple flavor sizes',
    DOSAGE: 'Multiple dosages',
};
const AttributesList = ({ attributes }) => {
    return (React.createElement("ul", { className: "flex justify-between gap-2.5 px-2.5 md:px-3.5 xl:px-5 text-sm xl:text-base font-normal" }, attributes.map(({ attribute, values }) => {
        if (!values || !Array.isArray(values) || values.length === 0)
            return null;
        return (React.createElement(React.Fragment, { key: attribute },
            React.createElement("li", { className: "w-[1px] bg-brand-rule-grey first:hidden", "aria-hidden": "true" }),
            React.createElement("li", { className: "py-2.5 xl:py-3" }, values.length === 1
                ? values[0]
                : MultipleAttributeDictionary[attribute])));
    })));
};
export { ProductCard };
